module.exports = __webpack_public_path__ + "static/media/33-3.2d5d0d6a.mp3";